import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import Select from "react-select";
import SelectAsync from "react-select/async";
import CreatableSelect from "react-select/creatable";

import Textbox from "./../input/textbox";
import Textarea from "./../input/textarea";
import CKEditor from "./../input/ckeditor";
import FileUpload from "./../input/file-upload";
import Datepicker from "./../datepicker/datepicker";

import { helper } from "../../../util";
import CustomButton from "../../shared/button";

class Form extends Component {
    constructor(props) {
        super(props);

        this.handleDeleteImage = this.handleDeleteImage.bind(this);
        this.handleSelectImage = this.handleSelectImage.bind(this);
        this.changeSubmitText = this.changeSubmitText.bind(this);
        this.updateState = this.updateState.bind(this);

        this.state = {
            isSubmiting: false,
            SubmitText: null,
        };
    }

    componentDidMount() {
        $(this.form).checkify({
            message: {
                position: "right",
                required: "پر کردن این فیلد الزامی است.",
                email: "فرمت اطلاعات وارد شده صحیح نیست.",
                regex: "فرمت اطلاعات وارد شده صحیح نیست.",
                between: "فرمت اطلاعات وارد شده صحیح نیست.",
                number: "در این فیلد فقط می توانید عدد وارد کنید.",
                maxlen: "بیشترین تعداد کاراکتر مجاز {count} است.",
                minlen: "کمترین تعداد کاراکتر مجاز {count} است.",
            },
            onValid: (e) => {
                e.preventDefault();

                let formData = new FormData(),
                    obj = this.props.additionalPostData || {},
                    isValid = true;

                for (let i = 0; i < this.props.rows.length; i++) {
                    let cols = this.props.rows[i].cols;

                    for (let j = 0; j < cols.length; j++) {
                        let items = cols[j].items;

                        for (var k = 0; k < items.length; k++) {
                            let item = items[k];

                            if (item.type === "image") {
                                let visibility;
                                if (item.dependOn) {
                                    visibility =
                                        typeof this.state[
                                            item.dependOn.name
                                        ] === "object"
                                            ? item.dependOn.value
                                                  .split(",")
                                                  .indexOf(
                                                      this.state[
                                                          item.dependOn.name
                                                      ].value.toString()
                                                  ) != -1
                                            : item.dependOn.value
                                                  .split(",")
                                                  .indexOf(
                                                      this.state[
                                                          item.dependOn.name
                                                      ].toString()
                                                  ) != -1;
                                } else visibility = true;

                                if (
                                    visibility &&
                                    item.required &&
                                    this.state[item.name].length === 0 &&
                                    !this.state.file &&
                                    (!this.state.fileName ||
                                        this.state.fileName.length === 0)
                                ) {
                                    isValid = false;
                                    break;
                                }
                                if (this.state.file) {
                                    formData.append(
                                        "File",
                                        new Blob([this.state.file], {
                                            type: "application/octet-stream",
                                        }),
                                        this.state.fileName
                                    );
                                } else obj.FileName = this.state.fileName;

                                // TODO: CHECK AGAIN CODE!
                                if (this.state.picture)
                                    obj[this.toPascalCase(item.name)] =
                                        this.state.picture;
                            } else if (item.type === "select") {
                                obj[this.toPascalCase(item.name)] = item.isMulti
                                    ? this.state[item.name].map((x) => x.value)
                                    : this.state[item.name].value;
                            } else if (item.type === "checkbox") {
                                if (item.required && this.state[item.name] !== true) {
                                    isValid = false;
                                    break;
                                }
                                obj[this.toPascalCase(item.name)] =
                                    this.state[item.name];
                            } else
                                obj[this.toPascalCase(item.name)] =
                                    this.state[item.name];
                        }
                    }
                }

                formData.append(
                    "Data",
                    new Blob([JSON.stringify(obj)], {
                        type: "application/json",
                    })
                );

                if (isValid) {
                    this.setState({ isSubmiting: true });
                    this.props.onSubmit(formData, this.afterSubmit);
                } else {
                    this.props.onInvalid();
                }
            },
            onError: () => console.error(this.state),
        });
    }

    afterSubmit = () => this.setState({ isSubmiting: false });

    UNSAFE_componentWillMount() {
        for (let i = 0; i < this.props.rows.length; i++) {
            let cols = this.props.rows[i].cols;

            for (let j = 0; j < cols.length; j++) {
                let items = cols[j].items;

                for (var k = 0; k < items.length; k++)
                    this.setState({ [items[k].name]: items[k].defaultValue });
            }
        }
    }

    updateState(name, value) {
        this.setState({ [name]: value });
    }

    toPascalCase(text) {
        if ($.isNumeric(text)) return text;
        let x = text.replace(/([A-Z])/g, "$1");
        return x.charAt(0).toUpperCase() + x.slice(1);
    }

    generate() {
        let output = [];

        for (let i = 0; i < this.props.rows.length; i++) {
            let row = this.props.rows[i],
                cols = row.cols.map((col, colIndex) => (
                    <div key={colIndex} className={col.className}>
                        {col.items.map((item, i) => {
                            let visibility;
                            if (item.dependOn) {
                                visibility =
                                    typeof this.state[item.dependOn.name] ===
                                    "object"
                                        ? item.dependOn.value
                                              .split(",")
                                              .indexOf(
                                                  this.state[
                                                      item.dependOn.name
                                                  ].value.toString()
                                              ) != -1
                                        : this.state[item.dependOn.name] !=
                                              undefined &&
                                          item.dependOn.value
                                              .split(",")
                                              .indexOf(
                                                  this.state[
                                                      item.dependOn.name
                                                  ].toString()
                                              ) != -1;

                                // this.setState({ [item.name]: null })
                            } else visibility = true;

                            return visibility ? (
                                <div key={i} className="form-group">
                                    {this.getControl(item)}
                                </div>
                            ) : (
                                <div key={i} />
                            );
                        })}
                    </div>
                ));

            if (!row.type || row.type === "row")
                output.push(
                    <div key={i} className="row">
                        {cols}
                    </div>
                );
            else if (row.type === "fieldset") {
                output.push(
                    <fieldset key={i} className="dashboard__fieldset">
                        <legend>{row.title}</legend>
                        <div className="row">{cols}</div>
                    </fieldset>
                );
            }
        }

        return output;
    }

    isNumeric(attr) {
        return attr && attr["data-checkify"]
            ? attr["data-checkify"].indexOf("number") > -1
            : false;
    }

    getControl(item) {
        if (item.type === "textbox") {
            return (
                <Textbox
                    label={
                        item.label +
                        (item.required
                            ? ` (${helper.getResource("Required")})`
                            : "")
                    }
                    name={item.name}
                    value={this.state[item.name]}
                    numeric={this.isNumeric(item.attr)}
                    onChange={(e) => {
                        let value;
                        if (typeof item.onChange === "function")
                            value = item.onChange(e);
                        value = value || e.target.value;
                        this.setState({ [item.name]: value });
                    }}
                    {...item.attr}
                />
            );
        }

        if (item.type === "textarea") {
            return (
                <Textarea
                    label={
                        item.label +
                        (item.required
                            ? ` (${helper.getResource("Required")})`
                            : "")
                    }
                    name={item.name}
                    value={this.state[item.name]}
                    onChange={(e) => {
                        let value;
                        if (typeof item.onChange === "function")
                            value = item.onChange(e);
                        value = value || e.target.value;
                        this.setState({ [item.name]: value });
                    }}
                    {...item.attr}
                />
            );
        }

        if (item.type === "image") {
            let src =
                item.defaultValue === null || item.defaultValue.length === 0
                    ? ""
                    : `${this.props.pictureRootPath}/${item.defaultValue}`;

            return (
                <FileUpload
                    defaultValue={this.state.base64 ? this.state.base64 : src}
                    onDelete={() => this.handleDeleteImage(item.name)}
                    onSelect={this.handleSelectImage}
                />
            );
        }

        if (item.type === "select") {
            if (item.async) {
                return (
                    <div className="pos-rel">
                        <p className="label label-select2">
                            {item.label +
                                (item.required
                                    ? ` (${helper.getResource("Required")})`
                                    : "")}
                        </p>
                        {item.required ? (
                            <input
                                tabIndex={-1}
                                type="text"
                                style={{
                                    opacity: 0,
                                    height: 0,
                                    position: "absolute",
                                }}
                                value={
                                    item.isMulti
                                        ? this.state[item.name] &&
                                          this.state[item.name].length > 0
                                            ? this.state[item.name][0].value
                                            : ""
                                        : this.state[item.name]
                                        ? this.state[item.name].value
                                        : ""
                                }
                                data-checkify="required"
                                onChange={() => console.log(1)}
                            />
                        ) : (
                            ""
                        )}
                        <SelectAsync
                            name={item.name}
                            defaultValue={item.defaultValue || {}}
                            isMulti={item.isMulti || false}
                            isClearable={item.isClearable || false}
                            isRtl={item.isRtl || true}
                            isSearchable={item.isSearchable || true}
                            loadingMessage={() => "لطفا منتظر باشید ..."}
                            placeholder="..."
                            noOptionsMessage={() =>
                                "داده ای جهت نمایش وجود ندارد"
                            }
                            classNamePrefix="farashop-select"
                            onChange={(selected, _) =>
                                this.setState({ [item.name]: selected })
                            }
                            loadOptions={item.fetch}
                        />
                    </div>
                );
            }

            if (item.creatable) {
                return (
                    <div className="pos-rel">
                        <p className="label label-select2">
                            {item.label +
                                (item.required
                                    ? ` (${helper.getResource("Required")})`
                                    : "")}
                        </p>
                        {item.required ? (
                            <input
                                tabIndex={-1}
                                type="text"
                                style={{
                                    opacity: 0,
                                    height: 0,
                                    position: "absolute",
                                }}
                                value={
                                    item.isMulti
                                        ? this.state[item.name] &&
                                          this.state[item.name].length > 0
                                            ? this.state[item.name][0].value
                                            : ""
                                        : this.state[item.name]
                                        ? this.state[item.name].value
                                        : ""
                                }
                                data-checkify="required"
                                onChange={() => console.log(1)}
                            />
                        ) : (
                            ""
                        )}
                        <CreatableSelect
                            name={item.name}
                            defaultValue={item.defaultValue || {}}
                            isMulti={item.isMulti || false}
                            isClearable={item.isClearable || false}
                            isRtl={item.isRtl || true}
                            isSearchable={item.isSearchable || true}
                            loadingMessage={() => "لطفا منتظر باشید ..."}
                            placeholder="..."
                            noOptionsMessage={() =>
                                "داده ای جهت نمایش وجود ندارد"
                            }
                            classNamePrefix="farashop-select"
                            onChange={(selected, _) =>
                                this.setState({ [item.name]: selected })
                            }
                            loadOptions={item.fetch}
                        />
                    </div>
                );
            }

            return (
                <div className="pos-rel">
                    <p className="label label-select2">
                        {item.label +
                            (item.required
                                ? ` (${helper.getResource("Required")})`
                                : "")}
                    </p>
                    {item.required ? (
                        <input
                            tabIndex={-1}
                            type="text"
                            style={{
                                opacity: 0,
                                height: 0,
                                position: "absolute",
                            }}
                            value={
                                item.isMulti
                                    ? this.state[item.name] &&
                                      this.state[item.name].length > 0
                                        ? this.state[item.name][0].value
                                        : ""
                                    : this.state[item.name]
                                    ? this.state[item.name].value
                                    : ""
                            }
                            data-checkify="required"
                            onChange={() => console.log(1)}
                        />
                    ) : (
                        ""
                    )}
                    <Select
                        name={item.name}
                        options={item.options}
                        value={this.state[item.name] || item.defaultValue}
                        isMulti={item.isMulti || false}
                        isClearable={item.isClearable || false}
                        isRtl={item.isRtl || true}
                        isLoading={item.isLoading}
                        isSearchable={item.isSearchable || true}
                        loadingMessage={() => "لطفا منتظر باشید "}
                        placeholder="..."
                        noOptionsMessage={() => "داده ای جهت نمایش وجود ندارد"}
                        classNamePrefix="farashop-select"
                        onChange={(selected, _) => {
                            if (typeof item.onChange === "function")
                                item.onChange(selected);

                            if (item.isMulti && selected == null)
                                this.setState({ [item.name]: [] });
                            else this.setState({ [item.name]: selected });
                        }}
                    />
                </div>
            );
        }

        if (item.type === "editor") {
            return (
                <CKEditor
                    id={`txt${item.name}`}
                    value={this.state[item.name]}
                    label={
                        item.label +
                        (item.required
                            ? ` (${helper.getResource("Required")})`
                            : "")
                    }
                    events={{
                        change: (e) =>
                            this.setState({ [item.name]: e.editor.getData() }),
                    }}
                />
            );
        }

        if (item.type === "checkbox") {
            return (
                <div style={{ position: "relative", top: 9 }}>
                    <input
                        type="checkbox"
                        id={item.name}
                        checked={this.state[item.name]}
                        onChange={(e) =>
                            this.setState({ [item.name]: e.target.checked })
                        }
                        className="dashboard__custom-checkbox custom-checkbox__with-text"
                    />
                    <label htmlFor={item.name}>{item.label}</label>
                </div>
            );
        }

        if (item.type === "radio-list") {
            return (
                <ul className="dashboard__radio-list">
                    <li>{item.label}</li>
                    {item.items.map((x, i) => {
                        return (
                            <li key={i}>
                                <input
                                    type="radio"
                                    className="dashboard__custom-radio custom-radio__with-text"
                                    id={`${item.name}_${i}`}
                                    checked={this.state[item.name] === x.value}
                                    value={x.value}
                                    onChange={(e) => {
                                        if (typeof item.onChange === "function")
                                            item.onChange(x.value);
                                        this.setState({ [item.name]: x.value });
                                    }}
                                    name={item.name}
                                />
                                <label htmlFor={`${item.name}_${i}`}>
                                    {x.label}
                                </label>
                            </li>
                        );
                    })}
                </ul>
            );
        }

        if (item.type === "datepicker") {
            return (
                <Datepicker
                    inputAttr={item.attr}
                    label={
                        item.label +
                        (item.required
                            ? ` (${helper.getResource("Required")})`
                            : "")
                    }
                    name={item.name}
                    timepicker={item.timepicker}
                    onClear={() => this.setState({ [item.name]: "" })}
                    value={this.state[item.name]}
                    onChange={(date) => this.setState({ [item.name]: date })}
                />
            );
        }

        if (item.type === "radio-image-list") {
            if (typeof item.items === "undefined") return <div></div>;
            return (
                <ul className="dashboard__radio-image-list">
                    <li>
                        <input
                            type="radio"
                            className="dashboard__custom-radio"
                            id="noImage"
                            checked={this.state[item.name] === -1}
                            value={-1}
                            onChange={(e) => this.setState({ [item.name]: -1 })}
                            name={item.name}
                        />
                        <label htmlFor={"noImage"}>بدون عکس</label>
                    </li>
                    {item.items.map((x, i) => {
                        let address =
                            "/images/DigitalMarketing/gallery/thumb/" +
                            x.Picture;
                        return (
                            <li key={i}>
                                <input
                                    type="radio"
                                    className="dashboard__custom-radio"
                                    id={`${item.name}_${i}`}
                                    checked={this.state[item.name] === x.ID}
                                    value={x.ID}
                                    onChange={(e) =>
                                        this.setState({ [item.name]: x.ID })
                                    }
                                    name={item.name}
                                />
                                <label htmlFor={`${item.name}_${i}`}></label>
                                <img src={address} />
                            </li>
                        );
                    })}
                </ul>
            );
        }
    }

    handleDeleteImage(itemName) {
        this.setState({
            fileName: "",
            [itemName]: "",
            base64: null,
            file: null,
        });
    }

    handleSelectImage(file, base64) {
        this.setState({
            file,
            fileName: file.name,
            base64,
        });
    }

    changeSubmitText(value) {
        this.updateState("SubmitText", value);
    }

    render() {
        console.warn("form component: render");

        return (
            <React.Fragment>
                <form ref={(el) => (this.form = el)}>
                    {this.generate()}
                    <ul className="button-container list-unstyled">
                        <li>
                            {/* <button
                                disabled={this.state.isSubmiting}
                                type="submit"
                                className="btn btn-info btn-block"
                            >
                                {this.state.SubmitText ||
                                    this.props.submitButtonText ||
                                    "ثبت"}{" "}
                            </button> */}
                            <CustomButton
                                loading={this.state.isSubmiting}
                                type="submit"
                                className="btn btn-info btn-block"
                                rippleColor="rgba(0, 0, 0, 0.1)"
                                children={
                                    this.state.SubmitText ||
                                    this.props.submitButtonText ||
                                    "ثبت"
                                }
                            />
                        </li>
                        <li>
                            {this.props.cancelButtonLink && (
                                <Link
                                    disabled={this.state.isSubmiting}
                                    to={this.props.cancelButtonLink}
                                    className="btn btn-danger btn-block"
                                >
                                    انصراف
                                </Link>
                            )}
                        </li>
                    </ul>
                </form>
            </React.Fragment>
        );
    }
}

Form.propTypes = {
    rows: PropTypes.PropTypes.arrayOf(PropTypes.object).isRequired,
    cancelButtonLink: PropTypes.string,
    submitButtonText: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    additionalPostData: PropTypes.object,
};

export default Form;
